export var PlatformSupportStatus;
(function (PlatformSupportStatus) {
    PlatformSupportStatus["CHAIN_SUPPORTED"] = "chain_supported";
    PlatformSupportStatus["CHAIN_UNAVAILABLE"] = "chain_unavailable";
    PlatformSupportStatus["ACCOUNT_UNAVAILABLE"] = "account_unavailable";
})(PlatformSupportStatus || (PlatformSupportStatus = {}));
export var CreateOperationsStatus;
(function (CreateOperationsStatus) {
    CreateOperationsStatus["INSUFFICIENT_FUNDS"] = "insufficient_funds";
    CreateOperationsStatus["INSUFFICIENT_FUNDS_FOR_GAS"] = "insufficient_funds_for_gas";
    CreateOperationsStatus["INTERNAL"] = "internal";
    CreateOperationsStatus["INVALID_ARGUMENT"] = "invalid_argument";
    CreateOperationsStatus["NO_EXECUTION_PATH"] = "no_execution_path";
    CreateOperationsStatus["SUCCESS"] = "success";
})(CreateOperationsStatus || (CreateOperationsStatus = {}));
export var OperationDataFormat;
(function (OperationDataFormat) {
    OperationDataFormat["TRANSACTION"] = "transaction";
    OperationDataFormat["TYPED_DATA"] = "typed_data";
    OperationDataFormat["CENTRALIZED_EXCHANGE"] = "centralized_exchange";
})(OperationDataFormat || (OperationDataFormat = {}));
export var OperationOrigin;
(function (OperationOrigin) {
    OperationOrigin["EXTERNAL"] = "external";
    OperationOrigin["ORBY"] = "orby";
    OperationOrigin["USER"] = "user";
    OperationOrigin["SYSTEM"] = "system";
    OperationOrigin["ADMIN"] = "admin";
})(OperationOrigin || (OperationOrigin = {}));
export var Category;
(function (Category) {
    Category["SEND"] = "send";
    Category["RECEIVE"] = "receive";
    Category["SWAP"] = "swap";
    Category["SWAP_LEG"] = "swap_leg";
    Category["REBALANCE"] = "rebalance";
    Category["BRIDGE"] = "bridge";
    Category["FUNCTION_CALL"] = "function_call";
    Category["TYPED_DATA_SIGNATURE"] = "typed_data_signature";
    Category["PERP_OPEN"] = "perp_open";
    Category["PERP_REDUCE"] = "perp_reduce";
    Category["PERP_CLOSE"] = "perp_close";
    Category["FUNDING"] = "funding";
    Category["PREDICTION_BUY"] = "prediction_buy";
    Category["PREDICTION_SELL"] = "prediction_sell";
    Category["PREDICTION_RESOLUTION"] = "prediction_resolution";
    Category["CORRECTION"] = "correction";
    Category["DEPOSIT"] = "deposit";
    Category["WITHDRAWAL"] = "withdrawal";
    Category["MARGIN"] = "margin";
})(Category || (Category = {}));
export var OperationStatusType;
(function (OperationStatusType) {
    OperationStatusType["CANCELLED"] = "cancelled";
    OperationStatusType["FAILED"] = "failed";
    OperationStatusType["NOT_FOUND"] = "not_found";
    OperationStatusType["PENDING"] = "pending";
    OperationStatusType["SUCCESSFUL"] = "successful";
    OperationStatusType["WAITING_GAS_ABSTRACTION"] = "waiting_gas_abstraction";
    OperationStatusType["WAITING_TOKEN_APPROVAL_TRANSACTIONS"] = "waiting_token_approval_transactions";
    OperationStatusType["WAITING_PRECONDITION"] = "waiting_precondition";
    OperationStatusType["WAITING_TIMEOUT"] = "waiting_timeout";
})(OperationStatusType || (OperationStatusType = {}));
export var QuoteType;
(function (QuoteType) {
    QuoteType["EXACT_INPUT"] = "exact_input";
    QuoteType["EXACT_OUTPUT"] = "exact_output";
    QuoteType["ONRAMP"] = "onramp";
    QuoteType["TRANSFER"] = "transfer";
})(QuoteType || (QuoteType = {}));
export var Order;
(function (Order) {
    Order["NEWEST"] = "newest";
    Order["OLDEST"] = "oldest";
})(Order || (Order = {}));
export var ActivityStatus;
(function (ActivityStatus) {
    ActivityStatus["CANCELLED"] = "cancelled";
    ActivityStatus["FAILED"] = "failed";
    ActivityStatus["NOT_FOUND"] = "not_found";
    ActivityStatus["PENDING"] = "pending";
    ActivityStatus["SUCCESSFUL"] = "successful";
    ActivityStatus["WAITING_GAS_ABSTRACTION"] = "waiting_gas_abstraction";
    ActivityStatus["WAITING_TOKEN_APPROVAL_TRANSACTIONS"] = "waiting_token_approval_transactions";
    ActivityStatus["WAITING_PRECONDITION"] = "waiting_precondition";
    ActivityStatus["WAITING_TIMEOUT"] = "waiting_timeout";
})(ActivityStatus || (ActivityStatus = {}));
export var TokenAllowlistType;
(function (TokenAllowlistType) {
    TokenAllowlistType["ALL_TOKENS"] = "all_tokens";
    TokenAllowlistType["ONLY_FUNGIBLE_TOKENS"] = "only_fungible_tokens";
    TokenAllowlistType["ONLY_NON_FUNGIBLE_TOKENS"] = "only_non_fungible_tokens";
    TokenAllowlistType["ONLY_SEMI_FUNGIBLE_TOKENS"] = "only_semi_fungible_tokens";
})(TokenAllowlistType || (TokenAllowlistType = {}));
export var TimeIntervalUnits;
(function (TimeIntervalUnits) {
    TimeIntervalUnits["DAYS"] = "days";
    TimeIntervalUnits["FOREVER"] = "forever";
    TimeIntervalUnits["HOURS"] = "hours";
    TimeIntervalUnits["MINUTES"] = "minutes";
    TimeIntervalUnits["MONTHS"] = "months";
    TimeIntervalUnits["WEEKS"] = "weeks";
    TimeIntervalUnits["YEARS"] = "years";
})(TimeIntervalUnits || (TimeIntervalUnits = {}));
export var LIBRARY_TYPE;
(function (LIBRARY_TYPE) {
    LIBRARY_TYPE["VIEM"] = "viem";
    LIBRARY_TYPE["ETHERS"] = "ethers";
})(LIBRARY_TYPE || (LIBRARY_TYPE = {}));
